// eslint-disable-next-line @typescript-eslint/no-var-requires
import defaultTheme from 'tailwindcss/defaultTheme'

/** @type {import("@types/tailwindcss/tailwind-config").TailwindConfig } */
export default {
  darkMode: 'media', // or 'media' or 'class'
  theme: {
    extend: {
      fontSize: {
        26: '1.625rem',
        32: '2rem',
        34: '2.125rem'
      },
      fontFamily: {
        sans: ['Nexa', ...defaultTheme.fontFamily.sans]
      },
      colors: {
        black: {
          'high-emphasis': 'rgba(0, 0, 0, 0.8700000047683716)',
          'medium-emphasis': 'rgba(0, 0, 0, 0.6000000238418579)',
          disabled: '#9E9E9E',
          inactive: 'rgba(0, 0, 0, 0.5400000214576721)',
          icons: 'rgba(0, 0, 0, 0.8700000047683716)',
          darkest: '#000000'
        },
        white: {
          'high-emphasis': '#FFFFFF',
          'medium-emphasis': 'rgba(255, 255, 255, 0.699999988079071)',
          disabled: 'rgba(255, 255, 255, 0.5)',
          inactive: 'rgba(255, 255, 255, 0.5400000214576721)',
          light: 'rgba(255, 255, 255, 0.3199999928474426)'

        },
        gray: {
          darkest: '#323232',
          dark: 'rgba(0, 0, 0, 0.23999999463558197)',
          light: 'rgba(0, 0, 0, 0.03999999910593033)',
          neutral: '#F5F5F5',
          medium: '#666666',
          base: '#F8F8F8',
          divider: '#E5E5E5',
          inactive: '#D7D5D5',
          'chip-medium': '#E0E0E0',
          'chip-light': '#EBEBEB'
        },
        blue: '#337ab7',
        primary: {
          light: 'var(--color-primary-light)',
          DEFAULT: 'var(--color-primary)',
          dark: 'var(--color-primary-dark)',
          hover: 'var(--color-primary-hover)',
          active: 'var(--color-primary-active)'
        },
        secondary: {
          DEFAULT: 'var(--color-secondary)',
          hover: 'var(--color-secondary-hover)',
          active: 'var(--color-secondary-active)'
        },
        warning: {
          dark: '#FFA000',
          base: '#FFC107',
          light: '#FFF5E5',
          lightest: '#FFFAF3'
        },
        success: {
          dark: '#00C853',
          base: '#00E676',
          light: '#ECF9F3',
          lightest: '#F6FCF9'
        },
        error: {
          dark: '#C62828',
          base: '#E53935',
          light: '#FCE7E7',
          lightest: '#FEF4F4'
        },
        magenta: '#E40571',
        red: '#FF0033',
        yellow: '#FFDC5D',
        background: {
          dark: '#E8E8E8',
          light: '#FAFAFA'
        },
        'hover-overlay': {
          black: 'rgba(0, 0, 0, 0.07999999821186066)',
          'black-light': 'rgba(0, 0, 0, 0.03999999910593033)',
          white: 'rgba(255, 255, 255, 0.07999999821186066)',
          'white-light': 'rgba(255, 255, 255, 0.03999999910593033)'
        },
        'dark-black': '#212936',
        'dark-black-light': '#2B3648',
        'dark-divider': '#313C4E',
        'dark-light': '#56657F',
        'dark-white': '#8997B1',
        'dark-white-extra': '#AFBDD1'
      },
      boxShadow: {
        '1-dp': '0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)',
        '2-dp': '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)',
        '4-dp': '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)',
        '6-dp': '0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)',
        '9-dp': '0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2)',
        modal: '0px 19px 38px rgba(0, 0, 0, 0.3), 0px 15px 12px rgba(0, 0, 0, 0.22)',
        'vertical-sheet': '0px 9px 18px rgba(0, 0, 0, 0.18), 0px 6px 5px rgba(0, 0, 0, 0.24)',
        'horizontal-sheet': '0px 4px 4px rgba(0, 0, 0, 0.24)',
        style: '0px 4px 4px rgba(0, 0, 0, 0.25)'
      },
      width: {
        'modal-desktop': '656px',
        14: '3.5rem'
      },
      height: {
        'fit-content': 'fit-content',
        14: '3.5rem'
      },
      lineHeight: {
        '5/4': '126%'
      },
      letterSpacing: {
        '0.15px': '0.15px',
        '0.25px': '0.25px',
        '0.5px': '0.5px',
        '1.25px': '1.25px'
      },
      transitionProperty: {
        'background-color': 'background-color'
      },
      screens: {
        '2xl': '1440px'
      }
    }
  },
  variants: {
    backgroundColor: ({ after }) => after(['active', 'disabled'], 'hover')
  },
  plugins: [],
  content: [
    // Example content paths...
    './public/**/*.html',
    './src/**/*.{js,jsx,ts,tsx,vue}',
  ],
  future: {
    purgeLayersByDefault: true,
    removeDeprecatedGapUtilities: true
  }
}
